<header class="navbar  navbar-expand flex-md-row py-2 bd-navbar pr-0 bg-white" id="main-navigation">
    <a class="navbar-brand" (click)="navigateByLogo()">
        <img src="../../assets/images/logo.png" class="logo" alt="towerhill insurance logo">
    </a>
    <div class="welcome-text" *ngIf="isLoggedIn && firstName">Welcome {{ firstName }} {{ lastName }}!</div>
    <div class="spirelogo-centered d-md-none d-xl-block" *ngIf="isSpire">
        <a class="navbar-brand">
            <img src="../../assets/images/Spire_Logo_Teal_128x60.png"
                 title="High Value Homeowners Program" alt="High Value Homeowners Program"
                 class="spire-logo">
        </a>
    </div>
    <div class="d-md-none float-right ml-auto" id="mobile-main-menu">
        <figure *ngIf="isLoggedIn" class="glyph fs1 item" title="Logout" (click)="mobileMenu.hide();logout()">
            <img width="17" height="17" src="../../assets/images/icons/logout.svg" alt="log out">
            <figcaption class="caption mt-1">
                <small>Log Out</small>
            </figcaption>
        </figure>
        <figure class="glyph fs1 item" title="Menu" (click)="mobileMenu.toggle();getPolicies(policyRequestType.contactUs)">
            <img width="17" height="17" src="../../assets/images/icons/hamburger-icon.svg" alt="menu">
            <figcaption class="caption mt-1">
                <small>Menu</small>
            </figcaption>
        </figure>
    </div>
    <ul class="navbar-nav flex-row ml-md-auto d-md-flex d-none">
        <li class="nav-item d-xl-none" *ngIf="isSpire">
            <div>
                <a class="navbar-brand">
                    <img src="../../assets/images/Spire_Logo_Teal_128x60.png"
                         title="High Value Homeowners Program" alt="High Value Homeowners Program"
                         class="spire-logo">
                </a>
            </div>
        </li>
        <li class="nav-item" *ngIf="isLoggedIn">
            <figure class="item">
                <a class="nav-link border-left-0"
                   (click)="closeChatModal();contactUs.show();profile.hide();getPolicies(policyRequestType.contactUs);">
                    <img src="../../assets/images/icons/phone.svg" alt="contact us">
                    <figcaption class="caption mt-1">
                        <small>Contact Us</small>
                    </figcaption>
                </a>
            </figure>
        </li>
        <li class="nav-item">
            <figure class="item">
                <a class="nav-link" href="https://www.thig.com/faqs/" target="_blank"
                   (click)="closeChatModal();contactUs.hide();profile.hide();">
                    <img src="../../assets/images/icons/FAQs.svg" alt="FAQs">
                    <figcaption class="caption mt-1">
                        <small>FAQs</small>
                    </figcaption>
                </a>
            </figure>
        </li>
        <li class="nav-item" *ngIf="isLoggedIn">
            <figure class="item profile-alerts-popup">
                <a class="nav-link"
                   [outsideClick]="false"
                   [popoverContext]="context"
                   [popover]="popTemplate"
                   #profileAlertPopup="bs-popover"
                   containerClass="customClass"
                   placement="bottom"
                   triggers=""
                   (click)="profileAlertPopup.show();markUnreadAsRead();closeChatModal();contactUs.hide();profile.hide();">
                    <img src="../../assets/images/icons/notifications/Profile/profile-message.svg" alt="Messages">
                    <figcaption class="caption mt-1">
                        <small>Messages</small>
                        <span *ngIf="notificationsPayload?.numUnRead > 0">
            <span class="img-rounded float-right text-white position-relative text-center">{{ notificationsPayload?.numUnRead }}</span>
          </span>
                    </figcaption>
                </a>
            </figure>
            <!--Notification Popup starts here -->
            <ng-template #popTemplate class="notificatioWidth" id="notificationsPopups" let-message="message">
                <button type="button" (click)='profileAlertPopup.hide()' class="close pr-2" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <app-notifications
                        (filterNotifications)="filterNotifications($event)"
                        (showWarningModal)="showWarningModal($event)"
                        [filterOptions]="filterOptionsForProfileAlerts"
                        [notifications]="notificationsPayload"
                        [policy]=""
                        [notificationLocation]="'main-menu'"
                        [showFiltersPanel]="showFiltersPanel"
                        [showNotificationsPanel]="showNotificationsPanel">
                </app-notifications>
            </ng-template>
            <!--Notification Popup Ends here-->
        </li>
        <li class="nav-item" *ngIf="isChatEnabled">
            <figure class="item">
                <a class="nav-link" (click)="contactUs.hide();profile.hide();openChatModal()">
                    <img src="../../assets/images/icons/chat.svg" alt="chat with us">
                    <figcaption class="caption mt-1">
                        <small>
                            <ul class="float-right chat-option">
                                <li>Chat with us</li>
                                <li class="chat-timing">(8am - 6pm EST)</li>
                            </ul>
                        </small>
                    </figcaption>
                </a>
            </figure>
        </li>
        <li class="nav-item" *ngIf="isLoggedIn">
            <figure class="item">
                <a class="nav-link" (mouseover)="closeChatModal();profile.show();contactUs.hide();">
                    <img src="../../assets/images/icons/user.svg" class="mr-0" alt="my profile">
                    <figcaption class="caption mt-1">
                        <small>My Profile</small>
                    </figcaption>
                </a>
            </figure>
        </li>
        <li class="nav-item" (click)="profile.hide();logout()" *ngIf="isLoggedIn">
            <figure class="item">
                <a class="nav-link">
                    <img src="../../assets/images/icons/logout.svg" alt="log out">
                    <figcaption class="caption mt-1">
                        <small>Log Out</small>
                    </figcaption>
                </a>
            </figure>
        </li>
    </ul>
</header>

<!--Mobile navigation menu -->
<div class="modal fade ml-auto w-100 h-100" bsModal #mobileMenu="bs-modal" [config]="{backdrop: false, animated:false}"
     id="mobile-menu">
    <div class="modal-dialog m-0">
        <div class="modal-content p-4">
            <ul class="p-0">
                <li class="nav-item mb-4">
                    <a class="nav-link" *ngIf="isLoggedIn">
                        <img src="../../assets/images/icons/phone.svg" alt="contact us">Contact Us
                    </a>
                    <hr>
                    <ul class="sub-menu pl-4">
                        <li class="contact-us pb-2 clearfix bshadow0 pbs">
                            <span class="icon-Group-3634"></span>
                            Customer Care:
                            <strong class="strong">{{ contactInfo?.customerCarePhone }}</strong>
                        </li>
                        <li class="contact-us pb-2 clearfix bshadow0 pbs">
                            <span class="icon-Group-3634"></span>
                            Claims:
                            <strong class="strong">{{ contactInfo?.claimsPhone }}</strong>
                        </li>
                        <li class="contact-us pb-2 clearfix bshadow0 pbs">
                            <span class="icon-Fax"></span>
                            Fax:
                            <strong class="strong">{{ contactInfo?.fax }}</strong>
                        </li>
                        <li class="contact-us pb-2 clearfix bshadow0 pbs" *ngIf="contactInfo?.email!=null">
                            <span class="icon-Group-3676">
                                <span class="path1"></span><span class="path2"></span>
                            </span>Email:
                            <strong class="strong">{{ contactInfo?.email }}</strong>
                        </li>
                        <li class="contact-us pb-2 clearfix bshadow0 pbs" *ngIf="hasCpContactUsEmailFeature">
                            <button class="btn btn-primary" (click)="openMessageUsModal()">Message Us!</button>
                        </li>
                    </ul>
                </li>
                <li class="nav-item mb-4">
                    <a class="nav-link" href="https://www.thig.com/faqs/" target="_blank"
                       (click)="contactUs.hide();mobileMenu.hide();closeChatModal()">
                        <img src="../../assets/images/icons/FAQ.svg" alt="FAQs">FAQs
                    </a>
                </li>
                <li class="nav-item mb-4 profile-alerts-popup" *ngIf="isLoggedIn">
                    <a class="nav-link"
                       [outsideClick]="false"
                       [popoverContext]="context"
                       [popover]="popTemplate"
                       #profileAlertPopupMobile="bs-popover"
                       containerClass="customClass"
                       placement="bottom"
                       triggers=""
                       (click)="profileAlertPopupMobile.show();markUnreadAsRead();closeChatModal();">
                        <img src="../../assets/images/icons/notifications/Profile/profile-message.svg" alt="Messages">Messages
                        <span *ngIf="notificationsPayload?.numUnRead > 0">
              <span class="img-rounded text-white position-relative text-center">
                {{ notificationsPayload?.numUnRead }}
              </span>
            </span>
                    </a>
                    <!--Notification Popup starts here -->
                    <ng-template #popTemplate class="notificatioWidth" id="notificationsPopups" let-message="message">
                        <button type="button" (click)='profileAlertPopupMobile.hide()' class="close pr-2"
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <app-notifications
                                (filterNotifications)="filterNotifications($event)"
                                (showWarningModal)="showWarningModal($event)"
                                [filterOptions]="filterOptionsForProfileAlerts"
                                [notifications]="notificationsPayload"
                                [policy]=""
                                [notificationLocation]="'main-menu'"
                                [showFiltersPanel]="showFiltersPanel"
                                [showNotificationsPanel]="showNotificationsPanel">
                        </app-notifications>
                    </ng-template>
                    <!--Notification Popup Ends here-->
                </li>
                <li class="nav-item mb-4" *ngIf="isChatEnabled">
                    <a class="nav-link" (click)="contactUs.hide();mobileMenu.hide();openChatModal()">
                        <img class="float-left" src="../../assets/images/icons/chat.svg" alt="chat with us">
                        <ul class="chat-option">
                            <li>Chat with us</li>
                            <li class="chat-timing">(8am - 6pm EST)</li>
                        </ul>
                    </a>
                </li>
                <li class="nav-item mb-4">
                    <a class="nav-link" *ngIf="isLoggedIn">
                        <img src="../../assets/images/icons/user.svg" alt="my profile">My Profile
                    </a>
                    <hr>
                    <ul class="sub-menu pl-4" *ngIf="isLoggedIn">
                        <li class="icon-user mb-4" routerLink="/user-profile/my-profile">
                            <a class="ml-4 pl-2" (click)="mobileMenu.hide()">My Profile</a>
                        </li>
                        <li class="icon-prefs mb-4" routerLink="/user-profile/my-preferences">
                            <a class="ml-4" (click)="mobileMenu.hide()">My Preferences</a>
                        </li>
                        <li class="icon-password mb-4" routerLink="/user-profile/change-password">
                            <a class="ml-4 pl-2" (click)="mobileMenu.hide()">Change Password</a>
                        </li>
                        <li class="icon-edocs" routerLink="/user-profile/edocs-enrollment">
                            <a class="ml-4 pl-4" (click)="mobileMenu.hide()">eDocs enrollment</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>

<!--User Profile overlay-->
<div class="modal fade" bsModal #profile="bs-modal" [config]="{backdrop: false, animated:false}" id="profile">
    <div class="modal-dialog modal-sm m-0" (mouseleave)="profile.hide()">
        <div class="modal-content p-4">
            <ul class="pl-0 m-0">
                <li class="icon-user mb-3" routerLink="/user-profile/my-profile">
                    <a>My Profile</a>
                </li>
                <li class="icon-prefs mb-3" routerLink="/user-profile/my-preferences">
                    <a>My Preferences</a>
                </li>
                <li class="icon-password mb-3" routerLink="/user-profile/change-password">
                    <a>Change Password</a>
                </li>
                <li class="icon-edocs mb-3" routerLink="/user-profile/edocs-enrollment">
                    <a>eDocs enrollment</a>
                </li>
            </ul>
        </div>
    </div>
</div>

<!-- TP48272: Chat Application Modal -->
<div class="modal fade" bsModal #chat="bs-modal" [config]="{backdrop: false, animated:false}" id="chat"
     (onShow)="resetAllChatFormValues()">
    <div class="modal-dialog modal-md">
        <div class="modal-content p-4">
            <form [formGroup]="chatForm" (ngSubmit)="submitChatForm()" autocomplete="off"
                  action="https://pflgnvsocm01.thig.com/ccp/chat/form/100001"
                  target="_blank" method="post" #HTMLChatForm>
                <div class="form-group mb-3">
                    <div class="input-group">
                        <input type="text" name="extensionField_Name" formControlName="extensionField_Name"
                               class="form-control "
                               placeholder="Name*">
                    </div>
                    <div class="text-danger pt-2 pl-1 error-msg"
                         *ngIf="(chatFormSubmitted && chatForm.controls['extensionField_Name'].hasError('required'))">
                        This
                        is a required field
                    </div>
                    <div class="text-danger pt-2 pl-1 error-msg"
                         *ngIf="(chatFormSubmitted && chatForm.controls['extensionField_Name'].hasError('pattern'))">
                        Enter
                        a valid Name
                    </div>
                </div>
                <div class="form-group mb-3" *ngIf="!isLoggedIn">
                    <div class="input-group">
                        <input type="text" name="extensionField_Policy_Number"
                               formControlName="extensionField_Policy_Number" class="form-control "
                               placeholder="Policy Number" maxlength="10">
                    </div>
                    <div class="text-danger pt-2 pl-1 error-msg"
                         *ngIf="(chatFormSubmitted && chatForm.controls['extensionField_Policy_Number'].hasError('pattern'))">
                        Enter
                        a valid Policy
                        Number
                    </div>
                    <div class="text-danger pt-2 pl-1 error-msg"
                         *ngIf="(chatFormSubmitted && chatForm.controls['extensionField_Policy_Number'].hasError('minlength'))">
                        Policy
                        Number should be 10 characters
                    </div>
                </div>
                <div class="input-group mb-3" *ngIf="isLoggedIn">
                    <select class="form-control" name="extensionField_Policy_Number"
                            formControlName="extensionField_Policy_Number">
                        <option value="" selected>Select a policy</option>
                        <option *ngFor="let policy of policyList" [value]="policy">{{ policy }}</option>
                    </select>
                </div>
                <div class="form-group mb-3">
                    <div class="input-group">
                        <input type="text" name="extensionField_AddressLine1"
                               formControlName="extensionField_AddressLine1" class="form-control "
                               maxlength="60" placeholder="Address Line 1*">
                    </div>
                    <div class="text-danger pt-2 pl-1 error-msg"
                         *ngIf="(chatFormSubmitted && chatForm.controls['extensionField_AddressLine1'].hasError('required'))">
                        This
                        is a required field
                    </div>
                    <div class="text-danger pt-2 pl-1 error-msg"
                         *ngIf="(chatFormSubmitted && chatForm.controls['extensionField_AddressLine1'].hasError('pattern'))">
                        Please
                        enter a valid Address Line 1
                    </div>
                </div>
                <div class="form-group mb-3">
                    <div class="input-group ">
                        <input type="text" name="extensionField_City_State" formControlName="extensionField_City_State"
                               class="form-control"
                               placeholder="City State">
                    </div>
                    <div class="text-danger pt-2 pl-1 error-msg"
                         *ngIf="(chatFormSubmitted && chatForm.controls['extensionField_City_State'].hasError('pattern'))">
                        Please
                        enter a valid City
                    </div>
                </div>
                <div class="form-group mb-3">
                    <div class="input-group">
                        <input type="text" name="extensionField_Email" formControlName="extensionField_Email"
                               class="form-control "
                               placeholder="Email">
                    </div>
                    <div class="text-danger pt-2 pl-1  error-msg "
                         *ngIf="(chatFormSubmitted && emailErrMsg)"> {{ emailErrMsg }}
                    </div>
                </div>
                <div class="input-group mb-3">
                    <select class="form-control" name="extensionField_ccxqueuetag"
                            formControlName="extensionField_ccxqueuetag"
                            placeholder="Problem">
                        <option value="" selected>Select a problem</option>
                        <option value="Chat_Csq15">Billing/Policy Help</option>
                        <option value="Chat_Csq16">Website Help</option>
                    </select>
                </div>
                <button type="submit" class="btn btn-primary w-100 " name="btnSubmit">Begin Chat</button>
                <input type="hidden" name="author" value="Customer"/>
                <input type="hidden" name="title" value="ccx chat"/>
                <input type="hidden" name="extensionField_h_widgetName123456" value="CS_Chat"/>
                <!-- The following optional, hidden fields are available in order to customize the Customer Chat user interface.
                            Unlike other extension fields, these are not added to the social contact, and therefore do not display in the Agent Chat user interface.-->
                <input type="hidden" name="extensionField_chatLogo"
                       value="https://www.thig.com/assets/themes/thig/images/THIG-Logo.png">
                <input type="hidden" name="extensionField_chatWaiting"
                       value="Welcome. Please wait while we connect you to a customer service representative.">
                <input type="hidden" name="extensionField_chatAgentJoinTimeOut"
                       value="All customer service representatives are busy. Please wait or try again later.">
                <input type="hidden" name="extensionField_chatError"
                       value="Sorry, the chat service is currently not available. Please try again later.">
            </form>
        </div>
    </div>
</div>

<!--User contact us overlay-->
<div class="modal fade" bsModal #contactUs="bs-modal" [config]="{backdrop: false, animated:false}" id="contactUs">
    <div class="modal-dialog modal-md m-0" (mouseleave)="contactUs.hide()">
        <div class="modal-content m-3">
            <ul class="pl-0 m-0">
                <li class="mt-2 clearfix bshadow0 pbs">
                    <span class="icon-Group-3634"></span>
                    Customer Care:
                    <strong class="strong">{{ contactInfo?.customerCarePhone }}</strong>
                </li>
                <li class="mt-2 clearfix bshadow0 pbs">
                    <span class="icon-Group-3634"></span>
                    Claims:
                    <strong class="strong">{{ contactInfo?.claimsPhone }}</strong>
                </li>
                <li class="mt-2 clearfix bshadow0 pbs">
                    <span class="icon-Fax"></span>
                    Fax:
                    <strong class="strong">{{ contactInfo?.fax }}</strong>
                </li>
                <li class="mt-2 clearfix bshadow0 pbs" *ngIf="contactInfo?.email!=null">
                    <span class="icon-Group-3676">
                        <span class="path1"></span><span class="path2"></span>
                    </span>Email:
                    <strong class="strong">{{ contactInfo?.email }}</strong>
                </li>
                <li class="mt-2" *ngIf="hasCpContactUsEmailFeature">
                    <button class="btn btn-primary" (click)="openMessageUsModal()">Message Us!</button>
                </li>
            </ul>
        </div>
    </div>
</div>

<app-message-us-modal
    *ngIf="hasCpContactUsEmailFeature && showMessageUsModal"
    [customerDetails]="customerDetails"
    [policyList]="policyList"
    (closed)="showMessageUsModal=false">
</app-message-us-modal>

<p-dialog [modal]="true" [(visible)]="openNotificationWarningModal">
    <p-header>
        Warning
    </p-header>
    {{ modalMessage }}
    <p-footer class="text-center alert-box">
        <button type="button" (click)="openNotificationWarningModal=false; stopEventPropagation($event)"
                class="btn btn-primary footer-btn" style="width: auto !important; font-size: 1rem;">Cancel
        </button>
        <button type="button" (click)="openNotificationWarningModal=false; onModalConfirmClick($event)"
                class="btn btn-primary footer-btn" style="width: auto !important; font-size: 1rem;">
            OK
        </button>
    </p-footer>
</p-dialog>
